/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable consistent-return */

import { useCallback, useEffect, useRef } from 'react';
import useChartJsIntersectionObserver from '../../../../../hooks/intersectionObserver/charts/useChartJsIntersectionObserver';
import type ChartData from '../../../types/ChartData';
import createBarChart from './helpers/createBarChart';

const useBarChart = (canvas: any, data: ChartData) => {
    const chartRef = useRef<any>(undefined);

    const render = useCallback(() => {
        if (!canvas.current) return;
        if (chartRef.current) return;

        chartRef.current = createBarChart(canvas.current, data);
    }, [canvas, data]);

    const { hasRenderedRef } = useChartJsIntersectionObserver({
        chartRef: canvas,
        animationDuration: 1000,
        threshold: 1,
        render,
    });

    /** render will change if the data changes */
    useEffect(() => {
        if (hasRenderedRef.current) {
            chartRef.current?.destroy();
            render();
        }
    }, [render, hasRenderedRef]);

    // eslint-disable-next-line arrow-body-style
    useEffect(() => {
        return () => {
            chartRef.current?.destroy();
            chartRef.current = null;
        };
    }, [canvas, data]);
};

export default useBarChart;
